import '../appComponents/desktop/css/DesktopModalStyles.css';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import '../appComponents/shared/css/PlatformExperience.css';
import './css/AccountSettingsPolish.css';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import React, { Component } from 'react';

class AccountManagementDesktopRender extends Component {
  render() {
    const { API, AWS, Amplify, Auth, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, Chart, Component, Container, Form, FormField, Fragment, Header, Icon, Image, LENDERBLOCKADMINWHITELIST, LeftNavBar, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PIXELAJUST, Radio, React, Storage, ThreeDot, USDEtherConversionRate, Web3, accountmanagement, addedContracts, addedContracts_creditLine, addedContracts_loanAgreement, allContracts, allContractsLooper, allDaysElapsed, allValues, applicantUsername, awsconfig, axios, bScoreFilterMax, bScoreFilterMin, blenderData, blenderPrivateKey, blenderScore, buttonColorFlashIntervalDefault, cardEntryFormTimer, cardFundComponent, chartData, chartDayRange, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, city, className, cognitoID, compoundedDebtSum, corporateBackedUsernamesArray, country, countryCodeSwappedJSON, countryCodeSwappedJSONList, countryCodes, countryNames, creditLineAddressArray, creditLineArray, currentLentSum, currentUser, currentUserCap, debounce, emailAddress, ethers, exitFundWalletTimer, exitTutorialTimer_1, exitTutorialTimer_2, exitTutorialTimer_3, fileDialog, filterSwitch, filterSwitchReloaded, firstName, flashCounter, forexJSON, fullAddress, fullName, fundWalletPromptDidBool, intRateMax, intRateMin, isMobile, joinDateSecs, lastName, lastNonce, lenderCtMax, lenderCtMin, lenders, loanAgreementArray, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, monthLengtheningEnum, navigationHandler, newMemberRegisterBool, noAccountsWarning_creditLine, noAccountsWarning_loanAgreement, notificationCount, notifs, openBorrowingContractsDetails_loanAgreement, openContracts, openLendingContractsDetails_loanAgreement, openStakingContractsDetails_loanAgreement, optionCountryCodeSwappedJSON, pageOrigin, postalCode, preSortedContractsArray, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, privateKey, proposeGasPrice, publicKey, rand1, rand2, rand3, rand4, randSum, ratingMax, ratingMin, recentlyViewedContracts, recentlyViewedContractsArray, resultMessageTimer, retrievedContractsArray, routeProps, scrollHeaderInterval, searchTimer, secondaryDisplayCurrency, secondaryDisplayPrice, squareCustomerID, stakedContractsList, state, street, that, tokenID, tokenLifeTimeLimit, topMoversArray, totalBorrContracts, touched, useLayoutEffect, useParams, useRef, userWishlist, username_wallet, verifyOverlayShownBool, walletBalance, web3, wishlistArray } = this.props;

    return (
(
          <div className={"pageBody tbp-platform tbp-platform--" + (that.state.mode_light_dark === 'light' ? 'light' : 'dark') + " tbp-platform--account-management tbp-platform--desktop"}>
              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

          
      
            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                open={that.state.errorTags}
                // open={true}
                style={{
                width: '25vw',
                justifyContent: 'center',
                alignItems: 'center',
                }}
            >

                <Modal.Header
                  style={{
                    paddingLeft: '7vh',
                  }}
                >
                  
                  The Blender Platform
                </Modal.Header>
                <Modal.Content 
                image
                style={{
                    justifyContent: 'space-between',
                    marginBottom: '1vh',
                }}
                >
                
                <Modal.Description
                    style={{
                    width: '25vw',
                    }}
                >
                    <Header
                    style={{
                        // left: '16vw',
                        fontSize: 20,
                        // position: 'absolute',
                        overflowY: 'hidden',
                        overflowX: 'hidden', 
                        width: '25vw',
                        marginBottom: 65,
                        paddingRight: '1vw',
                    }}
                    >
                        <p
                        style={{
                            color: 'rgba(235, 50, 38, 1)',
                            textAlign: 'left',
                            textWrap: 'wrap',
                        }}
                        >
                        {that.state.selectedLanguage == 'spanish' ? 
                            'Error:'
                                :
                            'Error:'
                        }
                        </p>
                        <p
                        style={{
                            color: 'rgba(0, 0, 0, 1)',
                            textAlign: 'left',
                            textWrap: 'wrap',
                            fontWeight: '400',
                            fontSize: 18,
                            paddingRight: '1vw',
                        }}
                        >
                        {that.state.errorTags}
                        </p>
                    </Header>
                </Modal.Description>
                </Modal.Content>
                <Button
                    content={
                        that.state.selectedLanguage == 'spanish' ? 
                        'Bueno'
                            :
                        'Okay'
                    }
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => {
                        that.setState({
                            successfulDepositOverlay: false,
                            errorTags: null
                        })
                    }}
                    positive
                    style={{
                        backgroundColor: 'rgba(0, 158, 129, 1)',
                        position: 'relative',
                        bottom: 21,
                        fontSize: 15,
                        width: '7vw',
                        marginLeft: '9vw',
                        marginRight: '9vw',
                        // left: '0vw',
                        borderRadius: 2,
                    }}
                />
            </Modal>


            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }}
              className={"tbp-desktop-modal tbp-overlay tbp-account-modal " + (that.state.mode_light_dark === 'light' ? 'light' : 'dark')}
              open={that.state.publicDisplayNameEditOverlay}
              size="small"
            >
              <Modal.Header>{that.state.selectedLanguage === 'spanish' ? 'Editar Apodo Público' : 'Edit Public Display Name'}</Modal.Header>
              <Modal.Content>
                <p className="tbp-account-modal__help">{that.state.selectedLanguage === 'spanish'
                  ? 'Elige el nombre que otros usuarios verán en tu perfil.'
                  : 'Choose the name other members will see on your profile.'}</p>
                <label className="tbp-account-modal__label" htmlFor="tbp-new-public-name">
                  {that.state.selectedLanguage === 'spanish' ? 'Apodo público' : 'Public display name'}
                </label>
                <input id="tbp-new-public-name" className="tbp-account-modal__input" type="text"
                  autoComplete="off" value={that.state.newDynamicPublicUsername || ''}
                  placeholder={that.state.selectedLanguage === 'spanish' ? 'Nuevo apodo público' : 'New public nickname'}
                  onChange={event => that.setState({newDynamicPublicUsername: event.target.value})}
                />
              </Modal.Content>
              <Modal.Actions className="tbp-account-modal__actions">
                <Button className="tbp-account-modal__secondary" icon="close"
                  content={that.state.selectedLanguage === 'spanish' ? 'Cancelar' : 'Cancel'}
                  onClick={() => {
                    that.setState({publicDisplayNameEditOverlay: false, newDynamicPublicUsername: null});
                    that.buildData();
                  }} />
                <Button className="tbp-account-modal__primary" icon="checkmark"
                  content={that.state.selectedLanguage === 'spanish' ? 'Guardar' : 'Save'}
                  onClick={() => {
                    authenticatedPut('api1169ba1e', '', {
                      headers: {Authorization: `Bearer ${cognitoID}`},
                      body: {
                        category: 'db', tableName: 'socialUserData',
                        primaryKey: that.state.currentUser, requestOperation: 'update',
                        updateExpression: `SET dynamicPublicUsername = :dynamicPublicUsername`,
                        expressionAttributeValues: {':dynamicPublicUsername': that.state.newDynamicPublicUsername}
                      }
                    }).then(res => {
                      that.setState({publicDisplayNameEditOverlay: false,successfulUpdateOverlay: true});
                      setTimeout(() => that.setState({successfulUpdateOverlay: false}), 3000);
                      that.buildData();
                    });
                  }} />
              </Modal.Actions>
            </Modal>

            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              
              
              open={that.state.successfulUpdateOverlay}
              // open={true}
              style={{
                width: '22vw',
                height: '8vw',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>

              <Modal.Content image>
                
                <Modal.Description>
                  <Header
                    style={{
                      left: '0vw',
                      marginTop: 5,
                      position: 'relative',
                    }}
                  >
                    {that.state.selectedLanguage == 'spanish' ? 
                      `Su perfíl se ha actualizado.`
                        :
                      `Your profile has been updated.`
                    }
                  </Header>
                  
                </Modal.Description>
              
                
                </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.mediaDeleteOverlay}
              // open={true}
              style={{
                width: '25vw',
                height: '25vh',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
                                      
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
              <Modal.Content image>
                
                <Modal.Description>
                  <Header
                    style={{
                      left: '2vw',
                      paddingRight: '2vw',
                      position: 'absolute',
                    }}
                  >
                    <p
                      style={{
                        fontSize: 19,
                        textAlign: 'left',
                      }}
                    >
                        {that.state.selectedLanguage == 'spanish' ? 
                          `Borrar esta media?  `
                            :
                          `Delete this media?  `
                        }
                      
                    </p>
                    
                  </Header>
                  
                  <div
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'center',
                      // alignItems: 'center',
                      position: 'absolute',
                      padding: 15,
                      bottom: 0, 
                      left: 0, 
                      right: 0,
                      width: '25vw',
                    }}
                  >
                    <Button
                      content="Delete"
                      labelPosition='right'
                      icon='remove circle'
                      
                      onClick={() => {
                        

                        authenticatedPut('api1169ba1e', '', { 
                          headers: { Authorization: `Bearer ${cognitoID}` },
                          body: { 
                              category: 'db',
                              tableName: 'socialUserData', 
                              primaryKey: String(currentUser), 
                              requestOperation: 'get',
                          }
                        }).then((userData) => {
                            let newMediaArray = []
                            if(userData.hasOwnProperty('Item')){
                                if(userData.Item.hasOwnProperty('mediaArray')){
                                    newMediaArray = userData.Item.mediaArray
                                    let indexToRemove = newMediaArray.indexOf(that.state.mediaItemToDelete.mediaFileName)
                                    newMediaArray.splice(indexToRemove,1)
                                }

                              
                                authenticatedPut('api1169ba1e', '', { 
                                    headers: { Authorization: `Bearer ${cognitoID}` },
                                    body: { 
                                        category: 'db',
                                        tableName: 'socialUserData', 
                                        primaryKey: currentUser, 
                                        requestOperation: 'update',
                                        updateExpression: 
                                            `SET 
                                                mediaArray = :newMediaArray
                                            `
                                        ,
                                        expressionAttributeValues: { 
                                            ':newMediaArray': newMediaArray
                                        }
                                    }
                                }).then((res) => {
                                    that.setState({ 
                                        mediaDeleteOverlay: false,
                                        mediaItemToDelete: {}
                                    })
                                })
                            }
                        })
                        

                      }}
                      positive
                      style={{
                        position: 'absolute',
                        right: 35,
                        bottom: 20,
                        marginLeft: 25,
                        backgroundColor: 'rgba(204, 12, 12, 1)',
                      }}
                    />

                    <Button className={"tbp-overlay-cancel"}
                      content="Cancel"
                      labelPosition='right'
                      icon='close'
                      
                      onClick={() => {
                        that.setState({
                          mediaDeleteOverlay: false,
                        })
                      }}
                      positive
                      style={{
                        position: 'absolute',
                        left: 35,
                        bottom: 20,
                        backgroundColor: 'rgba(0, 158, 129, 1)',
                      }}
                    />
                  </div>
                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>

                        <Modal centered={false} dimmer={{className: 'tbp-overlay-backdrop'}}
              className={'tbp-desktop-modal tbp-overlay tbp-account-modal ' + (that.state.mode_light_dark === 'light' ? 'light' : 'dark')}
              open={that.state.selectPrimaryLanguageOverlay}
              size="small"
            >
              <Modal.Header>{that.state.selectedLanguage === 'spanish' ? 'Idioma Principal' : 'Primary Language'}</Modal.Header>
              <Modal.Content>
                <p className="tbp-account-modal__help">{that.state.selectedLanguage === 'spanish'
                  ? 'Selecciona el idioma de la plataforma.' : 'Select your preferred platform language.'}</p>
                <div className="tbp-account-modal__language-options">
                  <Button icon="language" content="English" onClick={() => {
                    that.setState({selectPrimaryLanguageOverlay: false});
                    that.updatePrimaryLanguage('english');
                  }} />
                  <Button icon="language" content="Español" onClick={() => {
                    that.setState({selectPrimaryLanguageOverlay: false});
                    that.updatePrimaryLanguage('spanish');
                  }} />
                </div>
              </Modal.Content>
              <Modal.Actions className="tbp-account-modal__actions">
                <Button className="tbp-account-modal__secondary" icon="close"
                  content={that.state.selectedLanguage === 'spanish' ? 'Cancelar' : 'Cancel'}
                  onClick={() => that.setState({selectPrimaryLanguageOverlay: false})} />
              </Modal.Actions>
            </Modal>

            <div className="tbp-platform__sidebar" style={{
              // borderRadius: 10,
              justifyContent: 'center',
              alignItems: 'center',
              width: '13vw',
              height: '100vh',
              margin: 0,
              left: 0,
              position: 'absolute',
              borderRightStyle: 'solid',
              borderWidth: 0.1,
              borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
            }}>
              <Button
                onClick={() => {
                  that.setState({
                    navigationDestinationObject: {
                        navigationRoute: '/home',
                    },
                  })
                }}
                style={{
                  position: 'relative',
                  left: '2vw',
                  top: '1vw',
                  height: '5vw',
                  width: '5vw',
                  marginBottom: '2vh',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'rgba(0, 0, 0, 0)',
                }}
              >
                <img 
                  // className="logoImage" 
                  src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png"
                  style={{
                    height: '4vw',
                    width: '4vw',
                    position: 'absolute',
                    top: 7, 
                    left: 3, 
                    right: 0,
                    borderRadius: 7,
                    borderStyle: 'solid',
                    borderWidth: 0.1,
                    borderColor: 'rgba(177, 177, 177, 0.1)',
                  }}
                />
              </Button>


              <List>
                <ListItem
                  style={{
                    marginBottom: 10,

                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    className="ui huge teal button"
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/home',
                        },
                      })
                    }}
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="home icon"/>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Activos'
                          :
                        'Accounts'
                      }
                    </p>
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/browser',
                        },
                      })
                    }}
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    className="ui huge teal button"
                    
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="search icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Buscar'
                          :
                        'Browse'
                      }
                    </p>
                    
                  </button>
                </ListItem>

                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/newborrowingacct',
                        },
                      })
                    }}
                    className="ui huge teal button"
                      
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="newspaper icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Tomar Prestamo'
                          :
                        'Borrow Funds'
                      }
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/membertransactions',
                        },
                      })
                    }}
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="wait icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Transacciones'
                          :
                        'Transactions'
                      }
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/SubscriptionPlan',
                        },
                      })
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="star icon"></i>
                      &nbsp;  
                      {'Blender Pro Plus'}
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
                      win.focus();
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="book icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Condiciones'
                          :
                        'Terms of Use'
                      }
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
                      win.focus();
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="book icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Privacidad'
                          :
                        'Privacy Policy'
                      }
                    </p>
                    
                  </button>
                </ListItem>
              </List>




              <button 
                
                style={{
                  position: 'fixed',
                  bottom: 20,
                  marginBottom: 10,
                  marginLeft: 25,
                  borderRadius: 20,
                  backgroundColor: 'rgba(0, 158, 129, 0)',
                  borderWidth: 2,
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: 15,
                }}
                onClick={() => { 
                  trackPageRequest(Auth.signOut())
                  that.setState({
                    navigationDestinationObject: {
                        navigationRoute: '/welcome',
                    },
                  }) 
                }}
                className="ui medium teal button"
              >
                <p
                  style={{
                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                  }}
                >
                  <i className="sign out icon"/>
                  {that.state.selectedLanguage == 'spanish' ? 
                    'Desconectar'
                      :
                    'Sign Out'
                  }
                </p>
              </button>
              
            </div>







            <div className="tbp-platform__workspace" style={{
              justifyContent: 'center',
              alignItems: 'center',
              width: '87vw',
              minHeight: '105vh',
              margin: 0,
              flexDirection: 'column',
              borderWidth: 0,    
              position: 'absolute',
              left: '13vw',
              top: '0vh',
              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
            }}>
            
              <div className="tbp-platform__topbar" style={{
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '87vw',
                height: '7vh',
                paddingLeft: '3vw',
                margin: 0,
                display: 'flex',
                flexDirection: 'row',
                paddingRight: '10vw',
                borderBottomStyle: 'solid',
                borderWidth: 0.1,
                borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
              }}>
                <p 
                  style={{ 
                    textAlign: 'left',
                    textAlignVertical: 'center',
                    fontSize: 23, 
                    fontWeight: '600', 
                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                    marginTop: 30, 
                    width: '25vw',
                    marginBottom: 30,
                    marginRight: 25,
                    // textUnderlineOffset: 3, 
                    // textDecorationLine: 'underline', 
                    // textDecorationColor: 'rgba(255, 255, 255, 1)',
                  }}
                >
                    <span className="tbp-platform__eyebrow">THE BLENDER PLATFORM</span><span className="tbp-platform__title">{that.state.selectedLanguage === 'spanish' ? "Perfil" : "Profile"}</span>  
                </p>

              

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    position: 'absolute',
                    right: 0,
                    padding: 10,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingRight: 25,
                    borderRadius: 17
                  }}
                >
                  <Button
                    // onClick={() => {
                    //   that.setState({
                    //     navigationDestinationObject: {
                    //         navigationRoute: '/accountmanagement',
                    //     },
                    //   })
                    // }}
                    style={{
                      borderBottomLeftRadius: 18,
                      borderBottomRightRadius: 5,
                      borderTopLeftRadius: 18,
                      borderTopRightRadius: 5,
                      height: '40px',
                      borderWidth: 2,
                      marginLeft: 25,
                      marginRight: 10,
                      backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(35, 35, 35, 1)', 
                      borderColor: 'rgba(224, 225, 226, 0)',
                      borderStyle: 'solid', 
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      flexDirection: 'row',
                      transitionDuration: '0.4s',
                      cursor: 'pointer',
                      padding: 0,
                    }}
                  >
                    <img 
                      className="header_profileImage" 
                      width="35" 
                      height="35" 
                      src={that.state.currentUserProfilePicture}
                    />

                    <p 
                      style={{ 
                        textAlign: 'right',
                        textAlignVertical: 'center',
                        fontSize: 16, 
                        fontWeight: '600', 
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                        marginLeft: 12, 
                        marginRight: 15,
                        marginTop: 5,
                        // textUnderlineOffset: 3, 
                        // textDecorationLine: 'underline', 
                        // textDecorationColor: 'rgba(255, 255, 255, 1)',
                      }}
                    >
                        {String(that.state.currentUser).toUpperCase()}
                    </p>
                  </Button>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    position: 'absolute',
                    right: 200,
                    top: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 17,
                    backgroundColor: 'rgba(35, 35, 35, 0)',
                    borderRadius: 17,
                    width: '5vw',
                    height: '7vh', 
                  }}
                >


                  <button
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '2.5vw',
                      height: '7vh', 
                      paddingTop: '2.5vh',
                      paddingBottom: '1vh',
                      backgroundColor: 'rgba(35, 35, 35, 0)',
                      borderStyle: 'none',
                    }}
                    onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}
                  >
                    <p style={{ 
                      justifyContent: 'center',
                      textAlign: 'center',
                      textAlignVertical: 'center',
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                      fontWeight: '600',
                    }}>
                      <i
                        style={{
                          fontSize: that.state.mode_light_dark == 'dark' ? 34 : 31, 
                          marginBottom: 5, 
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          marginLeft: 5,
                        }}
                        className={that.state.mode_light_dark == 'dark' ? "sun icon" :"moon icon"}
                      />
                    </p>
                  </button>

                </div>   

              </div>




              <div className="tbp-platform__body tbp-account-scroll"
                style={{
                  // borderRadius: 10,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '87vw',
                  height: '93vh',
                  margin: 0,
                  borderStyle: 'none',
                  borderWidth: 0,
                  overflowY: 'scroll',
                  overflowX: 'hidden',
                  padding: 0,
                  scrollSnapType: 'y mandatory',
                  scrollBehavior: 'smooth'
                  // backgroundColor: 'blue',
                }}
              > 
                <div  
                  className="tbp-account-inner"
                  style={{
                    // borderRadius: 10,
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '87vw',
                    position: 'relative',
                    marginTop: 0,
                    // left: '13vw',
                    // top: 0,
                    // top: 0, 
                    // bottom: 0, 
                    // display: 'flex',
                    // flexDirection: 'column',
                    minHeight: '140vh',
                    marginTop: 0,
                    marginBottom: 0,
                    marginRight: 0,
                    // marginLeft: '65vw',
                    borderStyle: 'none',
                    borderWidth: 0,
                    scrollbarWidth: 'none',
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                    paddingBottom: '20vh',
                    // marginBottom: 
                    // backgroundColor: 'red',
                  }}
                >



                  

                    <div className="tbp-account-toolbar"
                      style={{
                        width: '87vw',
                        height: '10vh',
                        flexDirection: 'row',
                        display: 'flex',
                        paddingLeft: '3vw',
                        paddingTop: '4vh',
                        paddingBottom: '0px',
                        paddingRight: '7vw',
                        marginBottom: '3vh',
                        borderRadius: 3,
                        borderColor: 'rgba(177, 177, 177, 1)',
                        justifyContent: 'space-between',
                      }}
                    >
                      <p
                        style={{
                          fontSize: 25, 
                          textAlign: 'left',
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                        }}
                      >
                        <p
                          style={{
                            fontSize: 25, 
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            textAlign: 'left',
                          }}
                        >
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Configuración'
                            :
                            'Settings'
                          }
                        </p>
                      </p>

                      
                      <div
                        style={{
                          width: '50vw',
                          height: '4vh',
                          marginRight: '3vw',
                          // backgroundColor: 'red',
                          flexDirection: 'row',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                        }}
                      >




                        <button 
                          style={{
                            borderRadius: 20,
                            backgroundColor: 'rgba(0, 158, 129, 0)',
                            borderWidth: 2,
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: 15,
                            flexDirection: 'row',
                            display: 'flex',
                          }}
                          onClick={() => { 
                            that.setState({
                              publicDisplayNameEditOverlay: true
                            })
                          }}
                          className="ui medium teal button tbp-account-setting-btn"
                        >
                          <i 
                            style={{ 
                              fontSize: 20, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            }} 
                            className="address card icon"
                          />
                          <p
                            style={{
                              fontSize: 19,
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Apodo Público'
                              :
                              'Public Display Name'
                            }
                          </p>
                        </button>
                        <button 
                          style={{
                            borderRadius: 20,
                            backgroundColor: 'rgba(0, 158, 129, 0)',
                            borderWidth: 2,
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: 15,
                            flexDirection: 'row',
                            display: 'flex',
                          }}
                          onClick={() => { 
                            that.setState({
                              selectPrimaryLanguageOverlay: true
                            })
                          }} 
                          className="ui medium teal button tbp-account-setting-btn"
                        >
                          <i 
                            style={{ 
                              fontSize: 20, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            }} 
                            className="language icon"
                          />
                          <p
                            style={{
                              fontSize: 19,
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Idioma Primaria'
                              :
                              'Primary Language'
                            }
                          </p>
                        </button>
                        

                        

                      </div>





                    </div>
                  
                    {/* old modal */}
                    <div className="tbp-account-profile-wrap"
                      style={{
                        marginTop: 0,
                        marginBottom: '2vh',
                        position: 'relative',
                        width: '87vw',
                        height: '9vh',
                        // backgroundColor: 'rgba(224, 225, 226, 1)',
                      }}
                    >


        
                      <div className="tbp-account-profile-area" 
                        style={{
                          width: '70vw',
                          height: '100vh',
                          justifyContent: 'center',
                          alignItems: 'center',
                          // backgroundColor: 'rgba(224, 225, 226, 1)',
                        }}
                      >
                        <div className="tbp-account-profile-top"
                          style={{
                            flexDirection: 'row',
                            bottom: '2vh',
                            width: '80vw',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            // backgroundColor: 'red',
                          }}
                        >
                          <p
                            onClick={() => {
                              that.updateProfilePhoto()
                            }}
                            style={{
                              height: '10vw',
                              width: '10vw',
                              borderRadius: '5vw',
                              borderStyle: 'none',
                              justifyContent: 'center',
                              alignItems: 'center',
                              zIndex: 9999,
                              fontSize: 14,
                              marginBottom: 55,
                              // right: '11vw',
                              marginLeft: '1vw',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 
                              'EDITAR'
                              :
                              'EDIT'
                            }
                            {/* <i className="photo icon" size={50} style={{ opacity: 1, position: 'relative', fontSize: 35, fontWeight: '600', color: 'rgba(255, 255, 255, 1)', }}/> */}
                          </p>
                          <img className="tbp-account-avatar" 
                            onClick={() => { 
                              that.updateProfilePhoto()
                            }}
                            style={{
                              height: '10vw',
                              width: '10vw',
                              borderRadius: '5vw',
                              borderStyle: 'solid',
                              borderWidth: 2,
                              borderColor: 'rgba(177, 177, 177, 1)',
                              objectFit: 'cover',
                              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(41, 41, 41, 1)', 

                              top: 30,
                              left: '3vw',
                              position: 'absolute',
                            }}
                            size='small' 
                            src={that.state.socialOverlayData_imageURI} 
                            wrapped 
                          />
                      

                          <textarea className="tbp-account-bio"
                            type="text" 
                            id="textComment" 
                            wrap='soft'
                            rows="4"
                            // className="loginInput"  
                            value={that.state.socialOverlayData_bioString}
                            onChange={(event) => {
                              that.setState({
                                socialOverlayData_bioString: event.target.value,
                                bioActivelyEditingBool: true,
                              })
                            }} 
                            name="text"
                            maxlength="275"
                            placeholder={that.state.socialOverlayData_bioString} 
                            placeholderTextColor={'rgba(0, 0, 0, 1)'}
                            style = {{  
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                              fontSize: 21,
                              resize: 'none',
                              // fontWeight: '600',
                              textAlign: 'left',
                              textAlignVertical: 'top',
                              borderStyle: 'solid',
                              borderWidth: 1,
                              borderColor: 'rgba(255, 255, 255, 0)',
                              borderRadius: 4,
                              padding: '1vw',
                              // top: 25,
                              // left: 25,
                              // backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(220, 220, 220, 1)', 
                              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)',
                              marginRight: '3vw',
                              height: '10vw',
                              width: '85vw',
                              marginTop: '1.5vw',
                              marginLeft: '10vw',
                              textShadowColor: 'rgba(0, 0, 0, 0.10)',
                              textShadowOffset: {width: -1, height: 1},
                              textShadowRadius: 10, 
                              marginBottom: '2vh',

                            }}
                          />

                          {
                            !that.state.bioActivelyEditingBool
                            // false
                            ?
                            null
                            :
                            <div
                              style={{
                                justifyContent: 'space-around',
                                alignItems: 'center',
                                width: 55,
                                height: '9vw',
                                position: 'relative',
                                padding: 0,
                                backgroundColor: 'rgba(255, 255, 255, 0)',
                                // backgroundColor: 'blue',
                                display: 'flex',
                                flexDirection: 'column',
                                zIndex: 99999,
                              }}
                            >
                              <Button 
                                
                                onClick={()=> {

                                  authenticatedPut('api1169ba1e', '', { 
                                    headers: { Authorization: `Bearer ${cognitoID}` },
                                    body: { 
                                        category: 'db',
                                        tableName: 'socialUserData', 
                                        primaryKey: that.state.currentUser, 
                                        requestOperation: 'update',
                                        updateExpression: 
                                          `SET 
                                            bioString = :bioString
                                          `
                                        ,
                                        expressionAttributeValues: { 
                                          ':bioString': that.state.socialOverlayData_bioString,
                                        }
                                    }
                                  }).then((res) => {
                                    that.setState({
                                      successfulUpdateOverlay: true
                                    })
                                    setTimeout(() => {
                                      that.setState({
                                        successfulUpdateOverlay: false
                                      })
                                    }, 3000)
                                
                                    that.buildData()
                                  })

                                }}


                                style={{
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  fontSize: 15,
                                  width: 55,
                                  height: 45,
                                  backgroundColor: 'rgba(255, 255, 255, 0)',
                                  zIndex: 99999,
                                  marginTop: '3vh',
                                  top: 0,
                                  marginLeft: 5,
                                  //move needed
                                }}
                              >
                                <i 
                                  className="check icon" 
                                  size={35} 
                                  style={{ 
                                    position: 'relative', 
                                    color: 'rgba(0, 158, 129, 1)', 
                                    fontSize: 29,
                                    top: 0, 
                                    left: -5,
                                  }}
                                />
                              </Button>

                              <Button 
                                
                                onClick={()=> {
                                  that.setState({
                                    socialOverlayData_bioString: '',
                                    bioActivelyEditingBool: false,
                                  })  
                                  that.buildData()
                                }}


                                style={{
                                  // marginTop: 20,
                                  margin: 0,
                                  marginBottom: '2vh',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  fontSize: 15,
                                  width: 55,
                                  height: 45,
                                  zIndex: 9999,
                                  backgroundColor: 'rgba(255, 255, 255, 0)',
                                  zIndex: 99999,
                                  bottom: 0,
                                  //move needed
                                }}
                              >
                                <i 
                                  className="close icon" 
                                  size={35} 
                                  style={{ 
                                    position: 'relative', 
                                    color: 'rgba(204, 12, 12, 1)', 
                                    fontSize: 30,
                                    top: 0, 
                                    left: -5,
                                  }}
                                />
                              </Button>
                            </div>
                          }

                        </div>
              
                        


                        <div className="tbp-account-media" style={{marginBottom: 20, marginTop: 20, width: '80vw', justifyContent: 'center', alignItems: 'center', position: 'absolute', height: '80vh', top: '30vh',}}>
                            
                            <Button 
                              style={{
                                borderRadius: 2,
                                backgroundColor: 'rgba(0, 158, 129, 0)',
                                borderWidth: 2,
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: 15,
                                left: '3vw',
                                position: 'absolute',
                                top: '-6vh',
                              }}
                              onClick={() => { 
                                fileDialog({ 
                                  multiple: false, 
                                  accept: ['image/*', 'video/*'] 
                                }).then(file => {
                                    const data = new FormData()
                                    data.append('file', file[0])

                                    
                                      const reader = new FileReader();
                                  
                                      reader.onload = (e) => {
                                        const uri = e.target.result;

                                        let video_image_type = String(file[0].name).includes('video') ? 'video/mp4' : 'image/jpg';
                                        let video_image_ext = String(file[0].name).includes('video') ? 'mp4' : 'jpg';
                                        var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 18)

                                        let randomID = currentUser.toLowerCase().concat(randomString1)
                                        let fileName = `${currentUser.toLowerCase()}/${randomID}.${video_image_ext}`

                                        trackPageRequest(axios.get(uri, { responseType: 'arraybuffer' })).then((res) => {                                                          
                                          
                                            try{
                                                Storage.put(
                                                    fileName,
                                                    // uri,
                                                    res.data,
                                                    {         
                                                      level: 'public',
                                                    }
                                                ).then((res) => {

                                                    authenticatedPut('api1169ba1e', '', { 
                                                        headers: { Authorization: `Bearer ${cognitoID}` },
                                                        body: { 
                                                            category: 'db',
                                                            tableName: 'socialUserData', 
                                                            primaryKey: currentUser, 
                                                            requestOperation: 'update',
                                                            updateExpression: 
                                                                `SET 
                                                                    mediaArray = list_append(mediaArray, :mediaKey)
                                                                `
                                                            ,
                                                            expressionAttributeValues: { 
                                                                ':mediaKey': [fileName]
                                                            }
                                                        }
                                                    }).then((res) => {

                                                        authenticatedPut('api1169ba1e', '', { 
                                                            headers: { Authorization: `Bearer ${cognitoID}` },
                                                            body: { 
                                                                category: 'db',
                                                                tableName: 'mediaUploads', 
                                                                primaryKey: String(fileName), 
                                                                requestOperation: 'update',
                                                                updateExpression: 
                                                                    `SET 
                                                                        caption = :caption,
                                                                        uploadTimestamp = :uploadTimestamp,
                                                                        likesArray = :likesArray,
                                                                        commentsMapArray = :commentsMapArray
                                                                    `
                                                                ,
                                                                expressionAttributeValues: { 
                                                                    ':caption': '...',
                                                                    ':uploadTimestamp': Number(Date.now()),
                                                                    ':likesArray': [],
                                                                    ':commentsMapArray': [],
                                                                }
                                                            }
                                                        }).then((res) => {
                                                          that.setState({
                                                            successfulUpdateOverlay: true
                                                          })
                                                          setTimeout(() => {
                                                            that.setState({
                                                              successfulUpdateOverlay: false
                                                            })
                                                            that.buildData()
                                                          }, 3000)
                                                        })

                                                    })
                                                })
                                            } catch(err) {
                                            }                                                           

                                        })

                                      };
                                  
                                      reader.readAsDataURL(file[0]);  
                                      
                                })
                              }}
                              className="ui medium button"
                            >
                              <p
                                style={{
                                  fontSize: 20,
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                }}
                              >
                                <i 
                                  style={{ 
                                    fontSize: 20, 
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                  }} 
                                  className="upload icon"
                                />
                                
                                {that.state.selectedLanguage == 'spanish' ? 
                                  'SUBIR'
                                  :
                                  'UPLOAD'
                                }
                              </p>
                            </Button>


                          <div className="tbp-account-gallery-frame"
                            style={{
                              // objectFit: 'auto',
                              // borderStyle: 'solid',
                              justifyContent: 'center',
                              alignItems: 'center',
                              // display: 'flex',
                              // flexDirection: 'row',
                              // borderColor: 'blue',
                              position: 'relative',
                              marginTop: '5vh',
                              marginBottom: '5vh',
                              paddingTop: '5vh',
                              paddingBottom: '5vh',
                              borderRadius: 3, 
                              // marginLeft: 50,
                              // marginRight: 50,
                              zIndex: 99999,
                              height: '85vh',
                              // height: 700,
                              width: '80vw',
                              marginLeft: '3vw',
                              marginBottom: '5vw',
                              // MsOverflowStyle: 'none',  /* IE and Edge */
                              // scrollbarWidth: 'none',  /* Firefox */
                              // scrollSnapType: 'none',
                              // backgroundColor: 'red',
                            }}
                          >
                            <Button className="tbp-account-gallery-arrow tbp-account-gallery-arrow--prev"
                              style={{
                                // objectFit: 'auto',
                                // borderStyle: 'solid',
                                zIndex: 0,
                                display: 'flex',
                                flexDirection: 'row',
                                backgroundColor: 'rgba(0, 0, 0, 0)',
                                position: 'absolute',
                                // marginTop: '10vh',
                                // paddingBottom: '5vh',
                                borderRadius: 3, 
                                marginLeft: '1vw',
                                marginRight: '2vw',
                                // paddingRight: '2vw',
                                paddingLeft: 0,
                                height: '12vh',
                                // height: 700,
                                left: 15,
                                top: '33vh',
                                width: 25,  
                                marginLeft: 5,
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                              onClick={() => {
                                that.scrollMedia(Number(that.state.lastMediaItemIndexScrolled) - 1)
                              }}
                            >
                              <p 
                                style={{ 
                                  marginLeft: 10,
                                  marginBottom: 15,
                                  fontSize: 30, 
                                  textAlign: 'left', 
                                  textAlignVertical: 'center', 
                                  fontWeight: '600', 
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                }
                              }> 
                                <i className="angle left icon"/>
                              </p>
                            </Button>
                            <div
                              className="scrollContainer tbp-account-gallery-track"
                              style={{
                                zIndex: 999999,
                                // backgroundColor: 'red',
                                // objectFit: 'auto',
                                // borderStyle: 'solid',
                                justifyContent: 'start',
                                // alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'row',
                                borderColor: 'blue',
                                position: 'relative',
                                // marginTop: '5vh',
                                // marginBottom: '5vh',
                                paddingTop: '5vh',
                                paddingBottom: '5vh',
                                // paddingLeft: '70vw',
                                borderRadius: 3, 
                                // marginLeft: 50,
                                // marginRight: 50,
                                zIndex: 99999,
                                height: '85vh',
                                width: '71vw',
                                marginLeft: '4vw',
                                overflowX: 'scroll',
                                overflowY: 'hidden',
                                MsOverflowStyle: 'none',  /* IE and Edge */
                                scrollbarWidth: 'none',  /* Firefox */
                                scrollSnapType: 'none',
                                marginBottom: '5vh',
                                scrollbarWidth: 'none',  /* Firefox */
                                scrollSnapType: 'x mandatory',

                              }}
                            >
                              <React.Fragment>
                                {
                                  that.state.mediaMapArray
                                  ?
                                  that.state.mediaMapArray.map(listItemA => (
                                    

                                    <div 
                                      id={listItemA.itemIndex}
                                      className="scrollContainer tbp-account-gallery-item"
                                      style={{ 
                                        width: '70vh', 
                                        // marginTop: '10vh',
                                        height: '80vh',
                                        flexDirection: 'row',
                                        display: 'flex',
                                        // alignItems: 'center',
                                        // borderWidth: 1,
                                        // marginBottom: '8vh',
                                        marginLeft: 1,
                                        marginRight: '2vw',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        position: 'relative',
                                      }}  
                                      accessible={false}
                                    >


                                    <div className="tbp-account-gallery-card"
                                      style={{
                                        width: '70vh', 
                                        height: '80vh',
                                        position: 'relative',
                                        top: '-5vh',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginBottom: '2vh',
                                      }}
                                    >
                                      <Button className="tbp-account-gallery-delete"
                                          aria-label={that.state.selectedLanguage === 'spanish' ? 'Eliminar contenido' : 'Remove media'}
                                          style={{
                                            borderRadius: 22.5,
                                            height: 45, 
                                            width: 45,
                                            backgroundColor: 'rgba(255, 255, 255, 1)', 
                                            borderWidth: 2,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            padding: 15,
                                            right: 60,
                                            top: 35,
                                            zIndex: 99999,
                                            position: 'absolute',
                                          }}
                                          onClick={() => { 
                                            that.setState({
                                              mediaItemToDelete: listItemA.mediaFileName,
                                              mediaDeleteOverlay: true
                                            })
                                          
                                          }}
                                          
                                        >
                                          <p
                                            style={{
                                              fontSize: 25,
                                              top: 5,
                                              bottom: 5,
                                              left: 8,
                                              right: 8,
                                              position: 'absolute',
                                              color: 'rgba(204, 12, 12, 1)',
                                            }}
                                          >
                                            <i 
                                              style={{ 
                                                fontSize: 25, 
                                                color: 'rgba(204, 12, 12, 1)', 
                                              }} 
                                              className="close icon"
                                            />
                                          </p>
                                        </Button>
                                      {
                                        String(listItemA.mediaURI).includes("mp4")
                                        ?
                                        <video className="tbp-account-gallery-media"
                                          controls
                                          autoplay={true}
                                          ref={(ref) => {
                                              that.player = ref
                                          }}       
                                          style={{
                                            width: '65vh',
                                            height: '65vh',
                                            marginRight: 20,
                                            borderWidth: 1,
                                            borderColor: 'rgba(255, 255, 255, 1)',
                                            borderStyle: 'solid',
                                            borderRadius: 2,
                                            position: 'relative',
                                            marginBottom: 25,
                                            marginTop: 25,
                                            objectFit: 'cover',
                                          }} 
                                          fullscreen={listItemA.mediaURI == that.state.fullScreenViewerURI}
                                        >
                                          <source src={listItemA.mediaURI} type="video/mp4"/>  
                                        </video> 
                                        :
                                        <img className="tbp-account-gallery-media"
                                          style={{
                                            width: '65vh',
                                            height: '65vh',
                                            marginRight: 20,
                                            borderWidth: 1,
                                            borderColor: 'rgba(255, 255, 255, 1)',
                                            borderStyle: 'solid',
                                            borderRadius: 2,
                                            position: 'relative',
                                            marginBottom: 25,
                                            marginTop: 25,
                                            objectFit: 'cover',
                                          }} 
                                          
                                          src={listItemA.mediaURI}
                                        />
                                      }



                                          <div className="tbp-account-gallery-caption"
                                            style={{
                                              width: '65vh',
                                              height: '3vh',
                                              position: 'relative',
                                              marginTop: '5vh', 
                                              justifyContent: 'left',
                                              alignItems: 'center',
                                              // backgroundColor: 'green',
                                              padding: 0,
                                              marginBottom: '2vh',
                                              display: 'flex',
                                              flexDirection: 'row',
                                            }} 
                                          >
                                            <textarea className="tbp-account-gallery-caption-input"
                                              disabled={that.state.captionActivelyEditingURI != `${listItemA.mediaURI}` && that.state.captionActivelyEditingURI}
                                              wrap='soft'
                                              rows="4"
                                              maxlength="250"
                                              type="number" 
                                              id={listItemA.mediaURI} 
                                              outline="none"
                                              autocomplete="off"
                                              onChange={(event) => {
                                              
                                                that.setState({
                                                  captionActivelyEditingURI: listItemA.mediaURI,
                                                  newCaptionStringInput: event.target.value
                                                })  
                                                
                                              }} 
                                              name={listItemA.mediaURI}
                                              placeholder={`${listItemA.mediaItemCaption}`}      
                                              value={that.state.newCaptionStringInput}   
                                              placeholderTextColor={'rgba(0, 0, 0, 1)'}
                                              style={{ 
                                                fontWeight: '500',
                                                fontSize: 19,
                                                resize: 'none',
                                                font: 20,
                                                position: 'relative',
                                                placeholderTextColor: 'rgba(0, 0, 0, 1)',
                                                width: '58vh',
                                                height: '5vw',
                                                justifyContent: 'center', 
                                                padding: 10,
                                                alignItems: 'center', 
                                                textAlign: 'left', 
                                                textAlignVertical: 'top',
                                                borderWidth: 1,
                                                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(220, 220, 220, 1)', 
                                                
                                                borderColor: 'rgba(255, 255, 255, 1)',
                                                borderStyle: 'solid',
                                                borderRadius: 2,
                                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(0, 0, 0, 1)' ,
                                                wordBreak: 'breakAll',
                                                whiteSpace: 'normal',
                                              }}
                                            />

                                            {
                                              that.state.captionActivelyEditingURI != `${listItemA.mediaURI}`
                                              // true
                                              ?
                                              null
                                              :
                                              <div className="tbp-account-gallery-caption-actions"
                                                style={{
                                                  justifyContent: 'space-around',
                                                  alignItems: 'center',
                                                  width: 55,
                                                  height: '5vw',
                                                  position: 'absolute',
                                                  padding: 0,
                                                  backgroundColor: 'rgba(255, 255, 255, 0)',
                                                  // backgroundColor: 'rgba(0, 158, 129, 1)',
                                                  left: '58vh',
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  zIndex: 99999,
                                                }}
                                              >
                                                <Button 
                                                  
                                                  onClick={()=> {
                                                  
                                                    that.setState({
                                                      captionActivelyEditingURI: listItemA.mediaURI,
                                                    }, () => {

                                                      authenticatedPut('api1169ba1e', '', { 
                                                        headers: { Authorization: `Bearer ${cognitoID}` },
                                                        body: { 
                                                            category: 'db',
                                                            tableName: 'mediaUploads', 
                                                            primaryKey: String(listItemA.mediaFileName), 
                                                            requestOperation: 'update',
                                                            updateExpression: 
                                                              `SET 
                                                                  caption = :caption
                                                              `
                                                            ,
                                                            expressionAttributeValues: { 
                                                              ':caption': that.state.newCaptionStringInput,
                                                            }
                                                        }
                                                      }).then((res) => {
                                                        that.setState({
                                                          captionActivelyEditingURI: null
                                                        })
                                                      })
                                                    })  

                                                  }}


                                                  style={{
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    fontSize: 15,
                                                    width: 55,
                                                    height: 45,
                                                    backgroundColor: 'rgba(255, 255, 255, 0)',
                                                    zIndex: 99999,
                                                    margin: 0,
                                                    top: 0,
                                                    //move needed
                                                  }}
                                                >
                                                  <i 
                                                    className="check icon" 
                                                    size={35} 
                                                    style={{ 
                                                      position: 'relative', 
                                                      color: 'rgba(0, 158, 129, 1)', 
                                                      fontSize: 25,
                                                      top: -5, 
                                                      left: -5,
                                                    }}
                                                  />
                                                </Button>

                                                <Button 
                                                  
                                                  onClick={()=> {
                                                    that.setState({
                                                      newCaptionStringInput: '',
                                                      captionActivelyEditingURI: null,
                                                    })  

                                                  }}


                                                  style={{
                                                    // marginTop: 20,
                                                    margin: 0,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    fontSize: 15,
                                                    width: 55,
                                                    height: 45,
                                                    zIndex: 9999,
                                                    backgroundColor: 'rgba(255, 255, 255, 0)',
                                                    zIndex: 99999,
                                                    bottom: 0,
                                                    //move needed
                                                  }}
                                                >
                                                  <i 
                                                    className="close icon" 
                                                    size={35} 
                                                    style={{ 
                                                      position: 'relative', 
                                                      color: 'rgba(204, 12, 12, 1)', 
                                                      fontSize: 25,
                                                      top: 0, 
                                                      left: -5,
                                                    }}
                                                  />
                                                </Button>
                                              </div>
                                            }
                


                                          </div>
                                        
                                          
                                    </div>    





















                                      
                                    </div>



                                  
                                  ))
                                  : 
                                  null
                                } 
                              </React.Fragment>
                            </div>
                            <Button className="tbp-account-gallery-arrow tbp-account-gallery-arrow--next"
                                style={{
                                  // objectFit: 'auto',
                                  // borderStyle: 'solid',
                                  zIndex: 0,
                                  backgroundColor: 'rgba(0, 0, 0, 0)',
                                  // backgroundColor: 'red',
                                  position: 'absolute',
                                  // marginTop: '10vh',
                                  // paddingBottom: '5vh',
                                  borderRadius: 3, 
                                  // marginLeft: 50,
                                  // paddingRight: '2vw',
                                  height: '12vh',
                                  // height: 700,
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: 30,  
                                  top: '33vh',
                                  right: 15,
                                  paddingLeft: 10,
                                  padding: 0,
                                }}
                                onClick={() => {
                                  that.scrollMedia(Number(that.state.lastMediaItemIndexScrolled) + 1)
                                }}
                              >
                                <p 
                                  style={{ 
                                    marginBottom: 15,
                                    marginLeft: 0,
                                    fontSize: 30, 
                                    textAlign: 'left', 
                                    textAlignVertical: 'center', 
                                    fontWeight: '600', 
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                  }
                                }> 
                                  <i className="angle right icon"/>
                                </p>
                            </Button>
                          </div>  


                        





                            
                        </div>

                      </div>
                    </div>






                </div>



                <div 
                  style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '87vw',
                    height: '5vh',
                    margin: 0,
                    borderRadius: 0,
                    borderTopStyle: 'solid',
                    borderWidth: 0.1,
                    borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                    position: 'relative', 
                    bottom: 0,
                    paddingRight: '18vw',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    paddingTop: '1vw',
                    paddingBottom: '1vw',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                  className="tbp-site-footer"
                >
                  <Button
                    onClick={() => {
                      var win = window.open('https://lenderblockcorp.com/blenderplatform', '_blank');
                      win.focus();
                    }}
                    style={{
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                      height: '3vh',
                      borderWidth: 0,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 0,
                      marginRight: '5vw',
                    }}
                  >
                    <p
                      style={{
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                        fontWeight: '400',
                        fontSize: 15,
                        margin: 0,
                        textAlign: 'center',
                        textAlignVertical: 'center',
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish' ? 
                          'The Blender Platform es motorizada por Lenderblock Corporation.'
                          :
                          'The Blender Platform is Powered by Lenderblock Corporation.'
                      } 
                    </p>
                  </Button>

                  <Button
                    onClick={() => {
                      var win = window.open('https://lenderblockcorp.com/blenderplatform', '_blank');
                      win.focus();
                    }}
                    style={{
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                      height: '3vh',
                      borderWidth: 0,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    <p
                      style={{
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                        fontWeight: '400',
                        fontSize: 15,
                        margin: 0,
                        textAlign: 'center',
                        textAlignVertical: 'center',
                      }}
                    >
                      {'Copyright 2025.'} &nbsp; &nbsp; {'All rights reserved'}
                    </p>
                  </Button>
                </div>





                
              </div>

            </div>

          </div>
        )
    );
  }
}

export default AccountManagementDesktopRender;
